import { Footer } from "../../blocks/Footer/Footer";
import { MenuBottom } from "../../blocks/MenuBottom/MenuBottom";
import Header from "../../components/header/header";
import "../../core/core.css";
import { OrderDetails } from "../../features/order-details/ui/OrderDetails";
import { Services } from "../../features/service-list/ui/Services";
import "./../page.css";

const order = () => {
  return (
    <>
      <link rel="canonical" href="https://hmrep.ru/account/login/" />
      <div className="body">
        <Header></Header>
        <OrderDetails></OrderDetails>
        <div className="blocks">
          <Services></Services>
          <Footer></Footer>
        </div>
        <MenuBottom></MenuBottom>
      </div>
    </>
  );
};

export default order;
